import { useEffect } from 'react';
import { api } from '../api.js';
import ProtectedPageLoader from '../components/ProtectedPageLoader.jsx';
import { PALETTE } from '../palette.js';

const LEGACY_BRAND_SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,118}[a-z0-9])?$/;
const LEGACY_JOB_ID_PATTERN = /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]{0,158}[a-zA-Z0-9])?$/;
const WORKFLOW_JOB_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const LEGACY_BUILDING_FALLBACK_ROUTE = 'campaigns?notice=workflow-link-unavailable';

export function isSafeLegacyBuildingReference(brandSlug, legacyJobId) {
  return LEGACY_BRAND_SLUG_PATTERN.test(String(brandSlug || ''))
    && LEGACY_JOB_ID_PATTERN.test(String(legacyJobId || ''));
}

function activeCompanyId(session) {
  const memberships = session?.user?.memberships || [];
  return session?.user?.activeCompany?.id || memberships[0]?.companyId || '';
}

export default function LegacyBuildingRedirect({ navigate, params = [], session = {} }) {
  const [brandSlug = '', legacyJobId = ''] = params;
  const companyId = activeCompanyId(session);

  useEffect(() => {
    let active = true;
    const fallback = () => {
      if (active) navigate(LEGACY_BUILDING_FALLBACK_ROUTE, { replace: true });
    };

    if (!companyId || !isSafeLegacyBuildingReference(brandSlug, legacyJobId)) {
      fallback();
      return () => { active = false; };
    }

    const query = new URLSearchParams({ brandSlug, legacyJobId });
    api.get(`/api/saas/workflows/legacy-route?${query}`, {
      headers: { 'x-company-id': companyId },
    }).then((response) => {
      const workflowJobId = String(response?.workflowJobId || '');
      if (!WORKFLOW_JOB_ID_PATTERN.test(workflowJobId)) {
        fallback();
        return;
      }
      if (active) navigate(`workflow/${workflowJobId}`, { replace: true });
    }).catch(fallback);

    return () => { active = false; };
  }, [brandSlug, companyId, legacyJobId, navigate]);

  return (
    <div style={pageStyle}>
      <ProtectedPageLoader
        title="Opening campaign progress"
        body="Checking this saved campaign link against your active company before continuing."
        minHeight={280}
        style={{ maxWidth: 760 }}
      />
    </div>
  );
}

const pageStyle = {
  minHeight: '100vh',
  display: 'grid',
  placeItems: 'center',
  padding: 24,
  background: PALETTE.bg,
  fontFamily: 'Inter, sans-serif',
};
